export default __webpack_public_path__ + "img/a43d56202a5b96fce5e7cbb63f2b9eff.svg";